/*
|--------------------------------------------------------------------------
| site header search module
|--------------------------------------------------------------------------
*/

/* ========================================================================== *\
IMPORTS
\* ========================================================================== */

import $ from 'jquery';

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
CONSTANTS
\* ========================================================================== */

const
    /**
     * The module name
     * @type {String}
     */
    moduleName = 'site-header__search',

    /**
     * Lookup table for selectors
     * @type {Object}
     */
    selectors = {
        base: 'js-' + moduleName,
        form: 'js-' + moduleName + '__form',
        input: 'js-' + moduleName + '__input',
        button: 'js-' + moduleName + '__btn'
    },
    modifiers = {
        openModifier: '--is-open',
        activeModifier: '--is-active'
    },
    sitecoreEditMode = $('.sc-edit')

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
SETUP site header search
\* ========================================================================== */

const changeBtnState = (searchTerm) => {
    if (searchTerm.length) {
        $('.' + selectors.button).prop('disabled', false);
    } else {
        $('.' + selectors.button).prop('disabled', true);
    }
};

const handleInputChange = (e) => {
    //e.preventDefault();
    setTimeout(function () {
        changeBtnState($(e.currentTarget).val());
    },0);
};


/* == END SETUP site header search ===================================================== */

/* ========================================================================== *\
EVENT HANDLING
\* ========================================================================== */


const bindHandlers = () => {
    $('.' + selectors.input).on('keydown', handleInputChange);
   // $('.' + selectors.input).on('change', handleInputChange);
}


/* == END EVENT HANDLING ==================================================== */

/* ========================================================================== *\
INITIALIZATION
\* ========================================================================== */

/**
 * Initialize variant module
 */
function init() {
   bindHandlers();
}

if (document.getElementsByClassName('.' + selectors.base)){
    init()
}

/* == END INITIALIZATION ==================================================== */

/* ========================================================================== *\
EXPORTS
\* ========================================================================== */

// No exports, just default behaviour

/* == END EXPORTS ====================================================== */
